var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import styled from "styled-components";
import padding from "../global/padding";
import { greys } from "../global/colors";
var getLine = function (props) {
    if (props.dotted) {
        return "border-top: 1px dotted " + greys.light + ";";
    }
    else if (props.solid) {
        return "\n      border-top: 1px solid " + greys.mediumDark + ";\n    ";
    }
    return "border-top: 1px solid " + greys.light + ";";
};
function getMargin(props) {
    if (props.large) {
        return padding.base;
    }
    if (props.tiny) {
        return padding.tiny;
    }
    if (props.superTiny) {
        return padding.superTiny;
    }
    if (props.flush) {
        return "0";
    }
    return padding.small;
}
export var StyledHr = styled.hr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 1px;\n  ", "\n  ", "\n"], ["\n  width: 100%;\n  height: 1px;\n  ", "\n  ", "\n"])), function (props) { return getLine(props); }, function (props) { return "margin: " + getMargin(props) + " 0;"; });
export default function Hr(props) {
    return React.createElement(StyledHr, __assign({}, props, { "aria-hidden": "true" }));
}
var templateObject_1;
